export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-[#2D1B36] border-t border-[#FBF9F6]/10 py-14"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="text-center md:text-left">
        <p className="font-serif-d text-xl text-[#FBF9F6]">
          Innus <span className="italic text-[#C5A059]">Lace Centre</span>
        </p>
        <p className="font-accent text-[10px] tracking-[0.3em] uppercase text-[#FBF9F6]/40 mt-1">
          Art &amp; Craft · Karuna Complex, Court Road, N. Paravur
        </p>
      </div>
      <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-[#FBF9F6]/40">
        Secure Online Payments · Call +91 73565 72909
      </p>
    </div>
  </footer>
);
